import { useState, useCallback, useLayoutEffect, useMemo } from 'react'
import { useScreenContext } from '../../context/GlobalContext'
import useScrollListenerHook from './useScrollListenerHook'
import { setStickPoint } from './setStickPoint'

export default function useScrollUpdateHook(
  rnRef: React.RefObject<HTMLDivElement | null>,
  subBannerIsVisible: boolean,
) {
  const { innerHeight } = useScreenContext()
  const { scrollY: y } = useScrollListenerHook()
  const [rightNavRef, setRightNavRef] = useState<{
    height: number
    stick: number
  }>({ height: 0, stick: 0 })
  const [prevScrollVal, setPrevScrollVal] = useState(0)
  const [bufferComponentMarginTop, setBufferComponentMarginTop] = useState(0)
  const [scrollCheck, setScrollCheck] = useState<{
    amount: number
    dirFlag: number
  }>({ amount: 0, dirFlag: 0 }) // use this to...
  const [scrollDirection, setScrollDirection] = useState(0) // 0 = default start from 0 y-axis (scroll down); 1 = scrolled up from scroll down; 2 = scrolled down from scroll up
  const [marginRecalcFlag, setMarginRecalcFlag] = useState(0) // 0 = recalc activate when scrolled up, 1 = recalc activate when scrolled down

  const returnToComponent = useMemo(() => {
    return {
      scrollDirection,
      marginTop: bufferComponentMarginTop,
      stick: rightNavRef.stick,
      height: rightNavRef.height,
    }
  }, [
    scrollDirection,
    bufferComponentMarginTop,
    rightNavRef.stick,
    rightNavRef.height,
  ])

  const initStoreRefValues = useCallback(() => {
    if (!rnRef.current) return

    const rnbottom = rnRef.current.getBoundingClientRect()
    const newStickPoint = setStickPoint(innerHeight, rnbottom.height)
    setRightNavRef((prev) => {
      if (prev.height !== rnbottom.height || prev.stick !== newStickPoint) {
        return {
          height: rnbottom.height,
          stick: newStickPoint,
        }
      }
      return prev
    })
    // console.log(rightNavRef);
  }, [innerHeight, rnRef, rightNavRef])

  const updateScrollStates = useCallback(() => {
    // THIS FUNCTION ONLY DOES 90% OF ITS INTENDED FUNCTIONALITY... UNFORTUNATELY, I STILL LACK THAT 10% KNOWLEDGE NEEDED TO DEBUG THIS ERRATIC SCROLLING BEHAVIOR, BUT SOMEDAY I PROMISE THAT I'LL RETURN AND FIX THIS!!!! 9/10/2024 3:16 PM
    if (y === 0) {
      setBufferComponentMarginTop(0)
    } else if (prevScrollVal < y) {
      const a = y - prevScrollVal
      setPrevScrollVal(y)
      setScrollDirection((curr) => {
        if (curr === 1) {
          return 2
        }
        return curr
      })
      if (scrollCheck.amount >= rightNavRef.stick) {
        const newMargin = y - rightNavRef.stick
        if (marginRecalcFlag === 1 && newMargin !== bufferComponentMarginTop) {
          const v = y - rightNavRef.stick <= 0 ? 0 : y - rightNavRef.stick
          setBufferComponentMarginTop(v)
          setMarginRecalcFlag(0)
        }
      }
      if (scrollCheck.dirFlag === 1) {
        setScrollCheck((curr) => {
          if (curr.amount <= rightNavRef.stick) {
            const b = rightNavRef.stick - curr.amount
            return { ...curr, amount: b, dirFlag: 2 }
          }
          return { ...curr, amount: 0, dirFlag: 2 }
        })
      }
      if (scrollCheck.dirFlag === 2 || scrollCheck.dirFlag === 0) {
        setScrollCheck((curr) => {
          const b =
            curr.amount + a >= rightNavRef.stick
              ? rightNavRef.stick
              : curr.amount + a
          return { ...curr, amount: b }
        })
        // console.log(scrollCheck);
      }
    } else if (prevScrollVal > y) {
      const a = prevScrollVal - y
      setPrevScrollVal(y)
      setScrollDirection((curr) => {
        if (curr === 0 || curr === 2) {
          return 1
        }
        return curr
      })
      if (scrollCheck.amount >= rightNavRef.stick) {
        const newMargin = y - rightNavRef.stick
        if (marginRecalcFlag === 0 && newMargin !== bufferComponentMarginTop) {
          const v = y - rightNavRef.stick <= 0 ? 0 : y - rightNavRef.stick
          setBufferComponentMarginTop(v)
          setMarginRecalcFlag(1)
        }
      }
      if (scrollCheck.dirFlag !== 1) {
        setScrollCheck((curr) => {
          if (curr.amount <= rightNavRef.stick) {
            const b = rightNavRef.stick - curr.amount
            return { ...curr, amount: b, dirFlag: 1 }
          }
          return { ...curr, amount: 0, dirFlag: 1 }
        })
      }
      if (scrollCheck.dirFlag === 1) {
        setScrollCheck((curr) => {
          const b =
            curr.amount + a >= rightNavRef.stick
              ? rightNavRef.stick
              : curr.amount + a
          return { ...curr, amount: b }
        })
        // console.log(scrollCheck);
      }
    }
  }, [y, prevScrollVal, bufferComponentMarginTop, marginRecalcFlag])

  useLayoutEffect(() => {
    initStoreRefValues()
  }, [initStoreRefValues])
  useLayoutEffect(() => {
    if (subBannerIsVisible && rightNavRef.stick !== 0) {
      updateScrollStates()
    }
  }, [updateScrollStates])

  return returnToComponent
}
